import React from 'react';
import RadioButtonChecked from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import { StyledFormControlLabel, StyledRadio } from './Style/CustomRadio.style';

type CustomRadioProps = {
  value: string,
  label: string
};

const CustomRadio: React.FC<CustomRadioProps> = ({
  value,
  label
}) => {
  return (
    <StyledFormControlLabel
      value={value}
      control={
        <StyledRadio
          icon={<RadioButtonUnchecked sx={{ color: 'text.secondary' }} />}
          checkedIcon={<RadioButtonChecked sx={{ color: 'primary.main' }} />}
        />
      }
      label={label}
    />
  );
};

export default CustomRadio;
